import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import LoadingPage from "./LoadingPage.js";
import "../Components/Upload/Paste.css";

import { useSelector, useDispatch } from "react-redux";
import {
    TC_UNSAVED_ADD,
} from "../Constants/tcConstants.js";

const PasteUpload = () => {
  const dispatch = useDispatch();

  // const { tcid, tc, unsaveds } = useSelector((state) => state.tc);

  const navigate = useNavigate();
  const { user, isAuth } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [pastedContent, setPastedContent] = useState(localStorage.getItem('pastedContent') || ""); // Load from localStorage
  const [contractType, setContractType] = useState(localStorage.getItem('contractType') || "");
  const [product, setProduct] = useState(localStorage.getItem('product') || "");
  const [company, setCompany] = useState(localStorage.getItem('company') || "");


  useEffect(() => {
    localStorage.setItem('pastedContent', pastedContent);
    localStorage.setItem('contractType', contractType);
    localStorage.setItem('product', product);
    localStorage.setItem('company', company);

    return () => {
      localStorage.removeItem('pastedContent');
      localStorage.removeItem('contractType');
      localStorage.removeItem('product');
      localStorage.removeItem('company');
    };
  }, [pastedContent, contractType, product, company]);

  useEffect(() => {
    if (isAuth && user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
          document.documentElement.style.setProperty('--font-size-header', '1.5vw');
          document.documentElement.style.setProperty('--font-size-label', '14px');
          document.documentElement.style.setProperty('--font-size-input', '14px');
          document.documentElement.style.setProperty('--font-size-textarea', '14px');
          document.documentElement.style.setProperty('--font-size-button', '0.8vw');
          break;
        case 1: // Medium (default)
          document.documentElement.style.setProperty('--font-size-header', '2vw');
          document.documentElement.style.setProperty('--font-size-label', '16px');
          document.documentElement.style.setProperty('--font-size-input', '16px');
          document.documentElement.style.setProperty('--font-size-textarea', '16px');
          document.documentElement.style.setProperty('--font-size-button', '1vw');
          break;
        case 2: // Large
          document.documentElement.style.setProperty('--font-size-header', '3vw');
          document.documentElement.style.setProperty('--font-size-label', '24px');
          document.documentElement.style.setProperty('--font-size-input', '24px');
          document.documentElement.style.setProperty('--font-size-textarea', '24px');
          document.documentElement.style.setProperty('--font-size-button', '2vw');
          break;
        default:
          break;
      }
    } else if (!isAuth) { 
      document.documentElement.style.setProperty('--font-size-header', '2vw');
      document.documentElement.style.setProperty('--font-size-label', '16px');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-textarea', '16px');
      document.documentElement.style.setProperty('--font-size-button', '1vw');
    }
  }, [user, isAuth]);

  const handleFileUploadClick = () => {
    navigate('/fileupload');
  };

  const handleContentChange = (event) => {
    setPastedContent(event.target.value);
  };

  const handleContractTypeChange = (e) => setContractType(e.target.value);
  const handleProductChange = (e) => setProduct(e.target.value);
  const handleCompanyChange = (e) => setCompany(e.target.value);

  const handleAnalysisClick = async (event) => {
    event.preventDefault();

    if (!pastedContent.trim()) {
      alert("Please paste the document content... it's missing");
      return; 
    }

    if (!contractType) {
      alert("Please select a contract type.");
      return;
    }

    if (!product) {
      alert("Please enter the product T&C.");
      return;
    }

    if (!company) {
      alert("Please enter the company the product is under.");
      return;
    }
    
    try {
      setLoading(true);
      const response = await fetch('/analyze', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          content: pastedContent, 
          contractType, 
          product, 
          company 
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setLoading(false);
        // alert('File uploaded successfully inside FileUpload.js!');
        // find the tcid and unsavedId from here: 
        // console.log('tcid:', data.tcid);
        // console.log('unsavedId:', data.unsavedId);

        dispatch({ type: TC_UNSAVED_ADD, payload: { tcid: data.tcid, token: data.unsavedId } });
        localStorage.clear();
        navigate(`/analysis/${data.tcid}`, { state: { analysis: data.analysis } });
      } else {
        alert(`File upload failed: ${data.message}`);
        console.error(`File upload failed: ${data.message}`);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error at the end of fileUpload.js:', error);
      alert('File upload failed...');
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="container5">
      <div className="header5">Analyze your contract</div>
      
      <div className="container3">
        <div className="question-and-button">
          <p>What is your contract type?</p> 
          <div className="dropdown">
            <select id="dropdownSelect" className="dropbutton" value={contractType} onChange={handleContractTypeChange}>
              <option value="">Select an option</option>
              <option value="Terms and Conditions">Terms and Conditions</option>
              <option value="Private Policy">Private Policy</option>
              <option value="Housing">Housing</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
      </div>

      <div className="container3">
        <label htmlFor="input1" className="label1">What product is this T&C for?*</label>
        <input type="text" id="productInput" className="input1" name="input1" value={product} onChange={handleProductChange} />
      </div>

      <div className="container3">
        <label htmlFor="input1" className="label1">What company is the product under?*</label>
        <input type="text" id="companyInput" className="input1" name="input1" value={company} onChange={handleCompanyChange} />
      </div>


      <div className="paste-header3">Paste Your Document</div>
      <textarea id="docInput" className="input2" name="input2" rows="10" cols="80" value={pastedContent} onChange={handleContentChange}></textarea>

      <div className="container6">
        <button className="button2" onClick={handleFileUploadClick}>
            I want to upload my document instead...
          </button>
      </div>

      <div className="container2">
        <button className="upload-page-button" onClick={handleAnalysisClick}>
          Analyze Document
        </button>
      </div>

    </div>
  );
};

export default PasteUpload;
